module.exports = __webpack_public_path__ + "static/media/savio31.e1579789.jpg";